// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f61619d6","455":"8fbc93a8","456":"b5f75d5d","587":"589a948d"}[chunkId] + ".chunk.js";
};